import React from 'react';
import { Box, Grid, Typography, Paper, IconButton } from '@mui/material';
import {
  AddLink as AddLinkIcon,
  FilePresent as FilePresentIcon,
  Quiz as QuizIcon,
} from '@mui/icons-material';
import { TViews } from '.';

type TShareOption = {
  key: TViews;
  title: string;
  icon: JSX.Element;
};
interface ShareOptionsProps {
  onClick: (value: TViews) => void;
}

const ShareOptions: React.FC<ShareOptionsProps> = ({ onClick }) => {
  const options: TShareOption[] = [
    {
      key: 'link',
      title: 'Share Link',
      icon: <AddLinkIcon />,
    },
    {
      key: 'file',
      title: 'Share Documents',
      icon: <FilePresentIcon />,
    },
    {
      key: 'quiz',
      title: 'Share Quiz',
      icon: <QuizIcon />,
    },
  ];
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      bgcolor="#f5f5f5"
      borderRadius="20px"
    >
      <Grid
        container
        spacing={2}
        maxWidth="sm"
        padding="16px"
        justifyContent="center"
      >
        {options.map((option) => (
          <Grid key={option.key} item xs={6}>
            <Paper
              elevation={1}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: 2,
                borderRadius: 2,
                cursor: 'pointer',
                color: '#bdbdbd',
              }}
              onClick={() => onClick(option.key)}
            >
              <IconButton sx={{ color: '#bdbdbd' }}>{option.icon}</IconButton>
              <Typography variant="subtitle1" color="textSecondary">
                {option.title}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ShareOptions;
